"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SONDA_KIND = exports.actions = exports.ACTIONS = void 0;
/* eslint-disable default-param-last */
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
const deepmerge_1 = __importDefault(require("deepmerge"));
const next_utils_front_sonda_1 = __importStar(require("@gerenciatd/next.utils.front-sonda"));
const next_utils_metrics_1 = require("@gerenciatd/next.utils.metrics");
exports.ACTIONS = {
    /* SEO */
    GET_CURRENT_SEO: 'MAIN/GET_CURRENT_SEO',
    SET_CURRENT_SEO: 'MAIN/SET_CURRENT_SEO',
    REDIRECT_DEPENDS_ON_USER_TYPE: 'MAIN/REDIRECT_DEPENDS_ON_USER_TYPE',
    /* CONTEXT */
    SET_CONTEXT_DATA: 'MAIN/SET_CONTEXT_DATA',
    THROW_SONDA: 'MAIN/THROW_SONDA',
    /* nextjs */
    HYDRATE: 'MAIN/HYDRATE',
    REDIRECT: 'MAIN/REDIRECT',
    /* metrics */
    SEND_CMS_EVENT: 'MAIN/SEND_CMS_EVENT'
};
exports.actions = {
    /* SSEO */
    getCurrentSeo: (seoReqData) => ({
        type: exports.ACTIONS.GET_CURRENT_SEO,
        seoReqData,
    }),
    setCurrentSeo: (data) => ({ type: exports.ACTIONS.SET_CURRENT_SEO, data }),
    setContextData: (data) => ({ type: exports.ACTIONS.SET_CONTEXT_DATA, payload: data }),
    /* sonda */
    throwSonda: (data) => ({ type: exports.ACTIONS.THROW_SONDA, data }),
    sendCmsEvent: (taggingInfo, callBack) => ({ type: exports.ACTIONS.SEND_CMS_EVENT, taggingInfo, callBack }),
    redirectDependsOnUserType: (data) => ({
        type: exports.ACTIONS.REDIRECT_DEPENDS_ON_USER_TYPE,
        data,
    }),
    redirect: (data) => ({
        type: exports.ACTIONS.REDIRECT,
        data,
    }),
};
let context = `${process.env.NEXT_PUBLIC_CONTEXT}`;
try {
    context = JSON.parse(context);
}
catch (err) {
    console.error(err);
}
const initialState = {
    currentSeo: null,
    user: null,
    context,
};
function reducer(state = Object.assign({}, initialState), action) {
    switch (action.type) {
        case HYDRATE: {
            const { main } = action.payload;
            /* neceisto preservar lo que viene del sever excepto los filtros */
            const nextState = (0, deepmerge_1.default)(state, main);
            return nextState;
        }
        case exports.ACTIONS.SET_CURRENT_SEO:
            return Object.assign(Object.assign({}, state), { currentSeo: action.data });
        case exports.ACTIONS.SET_CONTEXT_DATA:
            return Object.assign(Object.assign({}, state), { context: Object.assign({}, action.payload) });
        case exports.ACTIONS.THROW_SONDA: {
            const { data } = action;
            const { filePath, processName } = data;
            const sonda = new next_utils_front_sonda_1.default({
                filePath,
                processName,
                context: state.context,
            });
            const { error, info, kind } = data;
            switch (kind) {
                case next_utils_front_sonda_1.SEVERITY_NAME.INFO:
                    sonda.infoMessage(info);
                    break;
                case next_utils_front_sonda_1.SEVERITY_NAME.FATAL:
                    sonda.fatalMessage({ error, info });
                    break;
                case next_utils_front_sonda_1.SEVERITY_NAME.SEVERAL:
                    sonda.severalMessage({ error, info });
                    break;
                case next_utils_front_sonda_1.SEVERITY_NAME.WARNING:
                    sonda.warningMessage({ error, info });
                    break;
                case next_utils_front_sonda_1.SEVERITY_NAME.ERROR:
                default:
                    sonda.errorMessage({ error, info });
                    break;
            }
            return Object.assign({}, state);
        }
        case exports.ACTIONS.SEND_CMS_EVENT: {
            const { taggingInfo, callBack } = action;
            const isFrontApp = typeof window !== 'undefined';
            const kebapContextInfo = (0, next_utils_metrics_1.createPageEventObject)(state.context);
            const isTaggingInfoValid = (0, next_utils_metrics_1.checkEventObj)(taggingInfo);
            const kebapTagingInfo = (0, next_utils_metrics_1.createEventObject)(taggingInfo);
            if (isFrontApp && window.nookInfoExchange && window.nookInfoExchange.sendMessage && isTaggingInfoValid && kebapContextInfo) {
                const res2send = Object.assign(Object.assign({}, kebapContextInfo), kebapTagingInfo);
                window.nookInfoExchange.sendMessage('Metrics', res2send);
            }
            else {
                console.error("No se pudo enviar a Metrics", res2send);
            }
            if (callBack && typeof callBack === 'function') {
                callBack();
            }
            return Object.assign({}, state);
        }
        default:
            return state;
    }
}
exports.SONDA_KIND = next_utils_front_sonda_1.SEVERITY_NAME;
exports.default = reducer;
//# sourceMappingURL=index.js.map